import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import { H3, Input, Span, Text, Textarea } from '@/components/atoms'
import { DatePickerField } from '@/components/molecules'
import type { ClaimsEditPageState } from '../page.claims-edit.hook'
import { FORM_PLACEHOLDER } from '@/shared/constants/forms'

interface ClaimsEditStepOnePageProps {
  page: ClaimsEditPageState
}

export function ClaimsEditStepOnePage({ page }: ClaimsEditStepOnePageProps) {
  const { t } = useTranslation()
  const { control, rules, fieldErrors } = page

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4 md:hidden">
        <H3 className="text-[2rem]! text-neutral-900">
          <Span textSize="">{t('claims.edit.titleStart')}</Span>
          <br />
          <Span textSize="" className="text-indigo-base!">
            {t('claims.edit.titleHighlight')}
          </Span>
        </H3>
        <Text className="text-neutral-900">{t('claims.edit.description')}</Text>
      </div>

      <H3 className="text-[1.5rem] text-neutral-900">
        {t('claims.pet.stepOne.title')}
      </H3>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <Controller
          control={control}
          name="invoiceDate"
          rules={rules.invoiceDate}
          render={({ field }) => (
            <DatePickerField
              id="invoiceDate"
              label={t('claims.pet.form.invoiceDateLabel')}
              placeholder={FORM_PLACEHOLDER.DATE}
              value={field.value}
              maxDate={page.today}
              error={fieldErrors.invoiceDate}
              onChange={field.onChange}
              onBlur={field.onBlur}
              dropdownMonthYear
              panelPosition="relative"
            />
          )}
        />
        <Controller
          control={control}
          name="amount"
          rules={rules.amount}
          render={({ field }) => (
            <Input
              id="amount"
              data-testid="claim-edit-amount-input"
              label={t('claims.pet.form.amountLabel')}
              placeholder={FORM_PLACEHOLDER.AMOUNT}
              inputMode="numeric"
              value={page.formatAmountCents(field.value)}
              error={fieldErrors.amount}
              onChange={(e) =>
                field.onChange(page.toAmountCents(e.target.value))
              }
              onBlur={field.onBlur}
            />
          )}
        />
      </div>

      <Controller
        control={control}
        name="description"
        rules={rules.description}
        render={({ field }) => (
          <Textarea
            id="description"
            data-testid="claim-edit-description-input"
            label={t('claims.pet.form.descriptionLabel')}
            maxLength={page.descriptionMaxLength}
            placeholder={t('claims.pet.form.descriptionPlaceholder')}
            value={field.value}
            error={fieldErrors.description}
            onChange={field.onChange}
            onBlur={field.onBlur}
          />
        )}
      />
    </div>
  )
}
